export enum AppRoutesEnum {
  AUTH = '/auth',
  CONTACT = '/contact',
  DASHBOARD = '/',
  WALLET = '/wallet',
  ASSETS = '/assets',
  NFTS = '/nfts',
  DEVELOPMENT = '/development',
  DEVELOPMENT_FAUCET = '/development/faucet',
  NFT_DETAIL = '/nft-detail',
  LENDING = '/lending',
  LENDING_SEED = '/lending/seed',
  LENDING_SPROUT = '/lending/sprout',
  LENDING_HARVEST = '/lending/harvest',
  STAKING = '/staking',
  ECOSYSTEM = '/ecosystem',
}
